import { EdnaMessageParser } from "../../../../models/EdnaChat";
import Mentionify from "../../../mentionify/Mentionify";

export const RenderText = ({ message }: { message: EdnaMessageParser }) => {
  return <Mentionify>{message.text}</Mentionify>;
};
